enum EOrigemTokenJWT {
  ERP = 'ERP',
  API = 'API',
  Indefinido = 'Indefinido',
}

export default EOrigemTokenJWT;
